import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgCheckOrder32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path d="M18 14a7 7 0 0 1 5.73 11.021l5.083 4.09a.5.5 0 0 1-.551.829l-.075-.05-5.09-4.093A7 7 0 1 1 18 14m0 1a6 6 0 1 0 0 12 6 6 0 0 0 0-12m3.465 3.167.081.064.222.213a.47.47 0 0 1 .052.627l-.062.067-4.97 4.52a.543.543 0 0 1-.659.057l-.07-.055-1.835-1.768a.482.482 0 0 1-.047-.624l.06-.07.221-.213a.533.533 0 0 1 .656-.061l.07.056 1.23 1.183 4.392-3.948a.555.555 0 0 1 .659-.048M20 2a1 1 0 0 1 1 1v9.5a.5.5 0 1 1-1 0V3H4v19h5.5a.5.5 0 1 1 0 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-2.5 10a.5.5 0 0 1 .09.992L17.5 13h-11a.5.5 0 0 1-.09-.992L6.5 12zm0-3a.5.5 0 0 1 .09.992L17.5 10h-11a.5.5 0 0 1-.09-.992L6.5 9zm0-3a.5.5 0 0 1 .09.992L17.5 7h-11a.5.5 0 0 1-.09-.992L6.5 6z" className="check-order-32_svg__path-1" /></SvgIcon>;
};
const Memo = memo(SvgCheckOrder32);
export default Memo;